export default __webpack_public_path__ + "alberta-chat-selected-badge.c2ddd68ab4f4e2dec7b8.svg";